import React from 'react';
import Dartboard from './Dartboard';

// Panneau qui regroupe toutes les interactions du joueur en cours
const CurrentPlayerPanel = ({
  currentTurn,
  turnScore,
  selectedMultiplier,
  onSelectMultiplier,
  directScoreInput,
  onChangeDirectScore,
  onApplyDirectScore,
  onAddDart,
  onValidateTurn,
  onCancelTurn,
  showDartboard,
  onToggleDartboard,
  canThrow,
  onDartboardHit,
  angleOffset
}) => {
  const hasDirectScore = currentTurn.some((dart) => dart.isDirect);

  // Rend un bouton de multiplicateur avec l'état actif/inactif
  const renderMultiplierButton = (label, value) => (
    <button
      className={`multiplier-btn ${selectedMultiplier === value ? 'active' : ''}`}
      onClick={() => onSelectMultiplier(value)}
    >
      {label}
    </button>
  );

  return (
    <>
      <div className="current-turn">
        <h4>Tour actuel:</h4>
        <div className="darts-display">
          {currentTurn.map((dart, dartIndex) => (
            <span key={dartIndex} className={`dart-score ${dart.isDirect ? 'direct-score' : ''}`}>
              {dart.isDirect
                ? `Score direct: ${dart.points}`
                : `${dart.multiplier > 1 ? `${dart.multiplier}x` : ''}${dart.basePoints} (${dart.points})`}
            </span>
          ))}
          {currentTurn.length < 3 && !hasDirectScore && (
            <span className="dart-placeholder">
              Fléchette {currentTurn.length + 1}
            </span>
          )}
        </div>
        <div className="turn-total">
          Total: {turnScore} points
        </div>
      </div>

      <div className="direct-score-section">
        <h4>Saisie directe du score:</h4>
        <div className="direct-score-input">
          <input
            type="number"
            placeholder="Score total du tour (0-180)"
            value={directScoreInput}
            onChange={(e) => onChangeDirectScore(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && onApplyDirectScore()}
            min="0"
            max="180"
            disabled={currentTurn.length > 0}
          />
          <button
            onClick={onApplyDirectScore}
            disabled={!directScoreInput || currentTurn.length > 0}
            className="btn-primary"
          >
            Valider et passer
          </button>
        </div>
        <p className="direct-score-help">
          💡 Saisissez votre score total et validez pour passer automatiquement au joueur suivant
        </p>
      </div>

      <div className="multiplier-selector">
        {renderMultiplierButton('Simple', 1)}
        {renderMultiplierButton('Double', 2)}
        {renderMultiplierButton('Triple', 3)}
      </div>

      <div className="points-grid">
        {Array.from({ length: 20 }, (_, i) => i + 1).map((num) => (
          <button
            key={num}
            className="point-btn"
            onClick={() => onAddDart(num)}
            disabled={!canThrow}
          >
            {num}
          </button>
        ))}
        <button
          className="point-btn bull-btn"
          onClick={() => onAddDart(25)}
          disabled={!canThrow}
        >
          Bull (25)
        </button>
      </div>

      <div className="turn-controls">
        <button
          className="control-btn btn-primary"
          onClick={onValidateTurn}
          disabled={currentTurn.length === 0}
        >
          Valider le tour ({turnScore} pts)
        </button>
        <button
          className="control-btn btn-secondary"
          onClick={onCancelTurn}
          disabled={currentTurn.length === 0}
        >
          Annuler le tour
        </button>
        <button
          className="control-btn btn-primary"
          onClick={onToggleDartboard}
        >
          {showDartboard ? 'Masquer la cible' : 'Afficher la cible'}
        </button>
      </div>

      <Dartboard
        visible={showDartboard}
        canThrow={canThrow}
        onHit={onDartboardHit}
        angleOffset={angleOffset}
      />
    </>
  );
};

export default CurrentPlayerPanel;

